import { Component, ElementRef, ViewChild } from '@angular/core';
import { take } from 'rxjs';
import { UserClerkService } from '../../core/user/user-clerk.service';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss',
})
export class SignupComponent {
  @ViewChild('clerkSignup', { static: true })
  private clerkSignupRef?: ElementRef;

  constructor(private userClerkService: UserClerkService) {}

  ngAfterViewInit() {
    this.userClerkService
      .init$()
      .pipe(take(1))
      .subscribe(() => {
        this.userClerkService.mountSignup(this.clerkSignupRef!.nativeElement);
      });
  }
}
